import prognosisReducer, { defaultState } from "./prognosisReducer";

export { defaultState };
export default prognosisReducer;
